<div class="redirecting">
  <div class="row">
    <div class="vert-center">
      <span class="redirect-loader"></span>
      <h1>
        Redirecting
        <span class="block">We won't be long</span>
      </h1>
    </div>
  </div>
</div>
